import {
  logger,
  PanelActionOutcome,
  ActionGesture,
  PanelRegion,
  PanelLaunchMethod,
} from "@mwt/web-js-telemetry";

import {
  ScenarioName,
  ScenarioType,
  ModuleName,
  ModuleSummary,
  PanelType,
} from "../telemetry/utils/constants";

export function logTestResultsSentToEpic() {
  logger.logPanelActionEvent({
    actionScenario: ScenarioName.SubmitTestResults,
    actionScenarioType: ScenarioType.DeviceTestSession,
    actionGesture: ActionGesture.Click,
    actionOutcome: PanelActionOutcome.Submit,
    moduleName: ModuleName.SubmitTestResultsButton,
    moduleSummary: ModuleSummary.SubmitTestResultsButton,
    panelType: PanelType.TestResults,
    panelLaunchMethod: PanelLaunchMethod.UserInitiated,
    panelRegion: PanelRegion.Main,
    panelUri: window.location.pathname,
  });
}
export function logSendResultsMutationResponse(response: boolean | undefined) {
  logger.logPanelActionEvent({
    actionScenario: response
      ? ScenarioName.SubmitTestResultsSuccess
      : ScenarioName.SubmitTestResultsFailure,
    actionScenarioType: ScenarioType.DeviceTestSession,
    actionGesture: ActionGesture.None,
    actionOutcome: PanelActionOutcome.Submit,
    moduleName: response
      ? ModuleName.SubmitTestResultsSuccess
      : ModuleName.SubmitTestResultsFailure,
    moduleSummary: response
      ? ModuleSummary.SubmitTestResultsSuccess
      : ModuleSummary.SubmitTestResultsFailure,
    panelType: PanelType.TestResults,
    panelLaunchMethod: PanelLaunchMethod.Direct,
    panelRegion: PanelRegion.Main,
    panelUri: window.location.pathname,
  });
}
